import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
export function useFocusInside() {
  const $ = _c(6);
  const [focused, setFocused] = useState(false);
  const ref = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setFocused(true);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleFocusIn = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setFocused(false);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleFocusOut = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const element = ref.current;
      if (element) {
        element.addEventListener("focusin", handleFocusIn);
        element.addEventListener("focusout", handleFocusOut);
        return () => {
          element.removeEventListener("focusin", handleFocusIn);
          element.removeEventListener("focusout", handleFocusOut);
        };
      }
    };
    t3 = [handleFocusIn, handleFocusOut, ref];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== focused) {
    t4 = {
      focused,
      ref
    };
    $[4] = focused;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}